<template>
  <tr :class="{ strikeout: eliminado }">
    <td>{{ item.linea }}</td>
    <td>{{ item.articulo.id }}</td>
    <td>
      {{ item.articulo.descripcion }}
      <div v-if="item.lote > -1" class="tag is-warning">
        Lote: {{ item.lote }}
      </div>
      <b-tooltip
        v-if="item.pedidoItemKit"
        type="is-info"
        :label="`Producto KIT: ${item.pedidoItemKit.articulo.id} - ${item.pedidoItemKit.articulo.descripcion}`"
        :delay="200"
      >
        <div class="tag is-info">Kit: {{ item.pedidoItemKit.articulo.id }}</div>
      </b-tooltip>
    </td>
    <td class="has-text-centered">{{ unidadMedida }}</td>
    <td class="has-text-right">{{ cantidadSolicitada }}</td>
    <td class="has-text-right">{{ cantidadEntregada }}</td>
    <td class="has-text-right">{{ item.stock }}</td>
    <td class="has-text-centered">
      <b-icon :icon="definirIcono(item.esCalzado)" />
    </td>
    <td>{{ item.numeroEntrega }}</td>
    <td class="has-text-centered">
      <div :class="badge">
        {{ item.tipoModificacion.nombre }}
      </div>
    </td>
  </tr>
</template>

<script>
import disponibilidadMixin from '@/mixins/disponibilidad.js'

export default {
  name: 'VisorPedidoItem',
  mixins: [disponibilidadMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    badge() {
      const badge = {
        tag: true
      }
      switch (`${this.item.tipoModificacion.id}`) {
        case '1':
          return Object.assign(badge, { 'is-warning': true })
        case '2':
          return Object.assign(badge, { 'is-success': true })
        case '3':
          return Object.assign(badge, { 'is-danger': true })
        default:
          return badge
      }
    },
    cantidadEntregada() {
      return this.item.cantidadEntregada * this.multiplo
    },
    cantidadSolicitada() {
      return this.item.cantidadSolicitada * this.multiplo
    },
    eliminado() {
      return [3, 4].includes(this.item.tipoModificacion.id)
    },
    hayMedidaInventario() {
      return (
        this.item.unidadMedida !==
        (this.item.unidadMedidaInventario ?? this.item.unidadMedida)
      )
    },
    multiplo() {
      return this.hayMedidaInventario ? this.item.multiplo : 1
    },
    unidadMedida() {
      return this.hayMedidaInventario
        ? this.item.unidadMedidaInventario
        : this.item.unidadMedida
    }
  }
}
</script>

<style lang="scss" scoped>
td {
  position: relative;
}

tr.strikeout td:before {
  content: ' ';
  position: absolute;
  top: 50%;
  left: 0;
  border-bottom: 1px solid #363636;
  width: 100%;
}

tr.strikeout td:after {
  content: '\00B7';
  font-size: 1px;
}
</style>
